module.exports = __webpack_public_path__ + "static/media/R171070.12cc30ab.jpg";